

























import {Component, Vue} from 'vue-property-decorator';
import {APIClient} from '@/api';
import SocialMediaSharer from '@/components/SocialMediaSharer.vue';
@Component({
  components: {SocialMediaSharer}
})
export default class Lemon extends Vue
{
  clicked = false;
  displayMessage = false;
  message: string | null = null;

  mounted()
  {
    // Because we're using a custom CSS transition (as opposed to a Vue exit/leave transition),
    // we need an animationend listener. Binding one can only happen from JS as far as I can tell,
    // so do it after the component mounts
    let lemon = this.$refs.lemon as Element;
    lemon.addEventListener('animationend', this.onAnimationEnd.bind(this));
  }

  onAnimationEnd()
  {
    // We want a small pause before the hover animation starts again, so we delay clearing the 'clicked' class
    setTimeout(() => this.clicked = false, 50);
  }

  async onClick()
  {
    this.clicked = true;

    // For the first click, we only need to load and display a message
    if (!this.message)
    {
      this.message = await APIClient.getMessage();
      this.displayMessage = true;
    }
    else
    {
      // Otherwise, we want to hide the message box and let the transition hook
      // load the new message
      this.displayMessage = false;
    }
  }

  async setNewMessage()
  {
    this.message = await APIClient.getMessage();
    this.displayMessage = true;
  }
}
